import { Component, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthAppService } from "sign-up-app/services/auth.service";

@Component({
    selector: 'verification-expired',
    templateUrl: './verification-expired.component.html',
    styleUrls: ['./verification-expired.component.less']
})
export class VerificationExpiredComponent {
    fullLiveUrl = window.fullLiveUrl;

    signInButtonText = $localize`Sign in to Brixx`;

    email: string = '';

    constructor(
        private router: Router,
        private authService: AuthAppService,
        private route: ActivatedRoute,
        private el: ElementRef
    ) { }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.email = params['login'];
        });
    }

    goToSignIn(): void {
        window.location.href = this.fullLiveUrl + 'sign-in';
    }

    goToMainSite(): void {
        window.location.href = "https://www.brixx.com";
    }

    resendVerificationEmail(): void {
        this.authService.resendVerificationEmail(this.email).then(response => {
            this.goToSignIn();
        });
    }
}
